import { render, staticRenderFns } from "./docs.vue?vue&type=template&id=7d6da426"
import script from "./docs.vue?vue&type=script&lang=js"
export * from "./docs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports